import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginCallbackComponent, LoginShellComponent } from '@iot-platform/auth';

const routes: Routes = [
  {
    path: 'login',
    children: [
      {
        path: '',
        component: LoginShellComponent
      },
      {
        path: 'callback',
        component: LoginCallbackComponent
      }
    ]
  },
  {
    path: '',
    loadChildren: () => import('@iot-platform/iot4bos/feature/app-shell').then((m) => m.appShellRoutes)
  },
  { path: '**', redirectTo: '/home' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      enableTracing: false,
      bindToComponentInputs: true,
      paramsInheritanceStrategy: 'always'
    })
  ],
  exports: [RouterModule]
})
export class AppRouterModule {}
